import React from 'react';
import { motion } from 'motion/react';

const TableBookingSkeleton: React.FC = () => {
  return (
    <div className="bg-black min-h-screen text-white">
      {/* Hero Section Skeleton */}
      <div className="relative h-96 bg-gray-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black" />
        <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
          <div className="space-y-4 w-full">
            <div className="h-12 w-3/4 bg-gray-800 rounded animate-pulse" />
            <div className="h-6 w-1/2 bg-gray-800 rounded animate-pulse" />
          </div>
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="max-w-7xl mx-auto px-6 py-12 space-y-12">
        {/* Event Details Skeleton */}
        <div className="space-y-4">
          <div className="h-8 w-48 bg-gray-800 rounded animate-pulse" />
          <div className="h-4 w-full bg-gray-800 rounded animate-pulse" />
          <div className="h-4 w-3/4 bg-gray-800 rounded animate-pulse" />
        </div>

        {/* Table Selector Skeleton */}
        <div className="space-y-4">
          <div className="h-6 w-32 bg-gray-800 rounded animate-pulse" />
          <div className="flex flex-wrap gap-3">
            {[1, 2, 3, 4, 5].map((index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                className="h-12 w-24 bg-gray-800 rounded-xl animate-pulse"
              />
            ))}
          </div>
        </div>

        {/* Time Slot Tabs Skeleton */}
        <div className="space-y-4">
          <div className="h-6 w-40 bg-gray-800 rounded animate-pulse" />
          <div className="flex flex-wrap gap-2 border-b border-gray-700 pb-4">
            {[1, 2, 3, 4].map((index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                className="h-16 w-32 bg-gray-800 rounded-lg animate-pulse"
              />
            ))}
          </div>
        </div>

        {/* Add-ons Section Skeleton */}
        <div className="space-y-6">
          <div className="h-8 w-48 bg-gray-800 rounded animate-pulse" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-gray-900/50 border border-gray-800 rounded-xl p-6 space-y-4"
              >
                <div className="h-6 w-3/4 bg-gray-800 rounded animate-pulse" />
                <div className="h-4 w-full bg-gray-800 rounded animate-pulse" />
                <div className="h-4 w-2/3 bg-gray-800 rounded animate-pulse" />
                <div className="h-8 w-24 bg-gray-800 rounded animate-pulse" />
              </motion.div>
            ))}
          </div>
        </div>

        {/* Floating Elements Skeleton */}
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50">
          <div className="h-16 w-64 bg-gray-800 rounded-2xl animate-pulse" />
        </div>
        <div className="fixed bottom-8 right-8 z-50">
          <div className="h-16 w-80 bg-gray-800 rounded-2xl animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default TableBookingSkeleton;

